import React, { useState } from "react";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../../utils/toaster.js";
import TemplatesTable from "./table/index.js";
import ModalWrapper from "../../../../common/modal/ModalWrapper.js";
import CreateTemplate from "./cteate-template/index.jsx";
import { deleteMedicineTemplate } from "../../../../../api/settings/Medicines/medicines.js";
import Button from "../../../../common/buttons/Button.js";
import FullScreeeSpinner from "../../../../common/loading/FullScreee.js";
import SearchInput from "../../../../common/search/index.js";
import EditTemplate from "./edit-template/index.jsx";

const ManageTemplates = ({
  loading,
  templates,
  getAllTemplatesData,
  setSearchKey,
  searchKey,
}) => {
  const [editOpen, setEditOpen] = useState(false);
  const [editData, setEditData] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [templateOpen, setTemplateOpen] = useState(false);
  const [editTemplateOpen, setEditTemplateOpen] = useState(false);
  const [editTemplateData, setEditTemplateData] = useState("");
  const handleconfirmation = (props) => {
    setConfirmOpen(!confirmOpen);
    setEditData(props);
  };

  const handleDelete = () => {
    deleteMedicineTemplate(editData._id)
      .then((response) => {
        showSuccessToast("Deleted Successfully");
        getAllTemplatesData();
        handleconfirmation();
      })
      .catch((error) => {
        console.log(error);
        showErrorToast(error, "error");
      })
      .finally(() => {});
  };
  const handleCreateTemplate = () => {
    setTemplateOpen(!templateOpen);
  };
  const handleEditTemplate = (params) => {
    setEditTemplateOpen(!editTemplateOpen);
    setEditTemplateData(params);
  };
  return (
    <div>
      <div className="grid lg:grid-cols-4 gap-2 mb-2">
        {/* Header Searchbar */}
        <div className="col-start-1 lg:col-end-3">
          <SearchInput
            placeholder={"Search by Medicine Name"}
            searchKey={searchKey}
            handleChange={setSearchKey}
          />
        </div>

        {/* Header add use Button */}
        <div className="lg:col-start-4 flex gap-2 w-full">
          <div className=" w-full">
            <Button
              onClick={handleCreateTemplate}
              type={"primary"}
              className={"text-bodyBB"}
            >
              Create Template{" "}
            </Button>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-[50vh]">
          <FullScreeeSpinner />
        </div>
      ) : (
        // Always render the table so the column headers stay visible; it
        // shows the empty state under them when there are no templates.
        <div>
          <TemplatesTable
            handleEditClick={handleEditTemplate}
            handleconfirmation={handleconfirmation}
            templates={templates}
          />
        </div>
      )}

      <ModalWrapper open={confirmOpen} handleClose={handleconfirmation}>
        <div className="flex flex-col gap-10">
          <div className="text-bodySRB max-w-[313px] w-full text-center text-darkgrey px-4">
            Are you sure that you want to delete
            <span className="text-bodyBB pl-1 pr-1 text-darkgrey">
              {editData?.medicine}
            </span>
            ?
          </div>
          <div className="flex gap-2">
            <Button
              onClick={handleconfirmation}
              type={"danger"}
              className={"text-heading2B"}
            >
              No
            </Button>
            <Button
              onClick={handleDelete}
              type={"yes"}
              className={"text-heading2B"}
            >
              Yes
            </Button>
          </div>
        </div>
      </ModalWrapper>

      <ModalWrapper open={templateOpen} handleClose={handleCreateTemplate}>
        <CreateTemplate
          handleClose={handleCreateTemplate}
          getAllTemplatesData={getAllTemplatesData}
        />
      </ModalWrapper>
      <ModalWrapper open={editTemplateOpen} handleClose={handleEditTemplate}>
        <EditTemplate
          handleClose={handleEditTemplate}
          editData={editTemplateData}
          getAllTemplatesData={getAllTemplatesData}
        />
      </ModalWrapper>
    </div>
  );
};

export default ManageTemplates;
